export function getBadgePrintLink(path) {
    return `/badges/print/${path}`;
}
